module.exports = __webpack_public_path__ + "static/img/gz-img05.6ae63e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gz-img05.jpg
// module id = DGh0
// module chunks = 1